import React from 'react';
import { FieldArray, change } from 'redux-form';
import { checkIsVisible } from '../../../HelperFunctions';
import GlassForm from './GlassForm'
import { connect } from 'react-redux';
import * as $ from 'jquery';
import ImportWrapper from '../../../../../components/authorised/order/edit/import/ImportWrapper';

class RenderGlass extends React.Component {

  handleAddNew() {
    const { fields, pprops, formValues } = this.props
    if (fields.length === 0) {
      fields.push({ ...formValues.finalized_glasses_attributes, id: null })
    }
    else {
      fields.push({ ...formValues.finalized_glasses_attributes[fields.length - 1], id: null })
    }
    setTimeout(() => pprops.submit(), 500)
  }

  handleAddFromExam() {
    const { pprops } = this.props
    setTimeout(() => pprops.submit(), 500)
    $(`#eyeglass-modal`).modal('show')
  }

  render() {
    const { template, isTemplate, fields, pprops, formName, prescription, prescriptionModule } = this.props
    return (
      <span>
        <div className='d-flex align-items-center justify-content-end'>
          {!isTemplate && (fields.length === 0) &&
            <button type="button" className="btn btn-primary float-right mt-5" onClick={() => this.handleAddNew(fields)}>
              <i className='la la-plus mr-2 font-size-16'></i>
              Add New
            </button>
          }
          {prescriptionModule && <div className='ml-4'>
            <ImportWrapper order={{ patient_id: prescription.patient_attributes?.id }} importName="eyeglass" prescription={prescription} prescriptionModule={prescriptionModule} importNameTitle="Previous Eyeglass Prescriptions" addBtnLabel="Add Previous Prescriptions" />
          </div>}
        </div>
        {fields.map((member, index) => (
          <div className="card-body">
            <div className="row my-5">
              <div className="col">
                <span className="badge badge-dark">Eyeglass Rx {index + 1}</span>
              </div>
            </div>
            <GlassForm
              {...this.props}
              name={`finalized_glasses_attributes[${index}]`}
              baseName={`finalize_prescription[eye_glass][eye_glasses][0]`}
              fieldValues={template['finalize_prescription']['eye_glass']['eye_glasses'][0]}
            />
            {!isTemplate &&
              <div className='row justify-content-between'>
                <div className='col-4'>
                  {(fields.length === index + 1) && pprops.exam?.pupillary_distance?.is_marked_complete && template.refraction_contact_lens_exam.refraction.fields?.pupillary_distance?.show_in_finalize_prescription && checkIsVisible(template.refraction_contact_lens_exam.refraction.fields.pupillary_distance.show_in_finalize_prescription) &&
                    <>
                      <strong>Pupillary Distance:</strong>
                      <table className='table table-bordered'>
                        <thead>
                          <th>Distance</th>
                          <th>Intermediate</th>
                          <th>Near</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>OD: {pprops.exam.pupillary_distance.od_distance}</td>
                            <td>OD: {pprops.exam.pupillary_distance.od_intermediate}</td>
                            <td>OD: {pprops.exam.pupillary_distance.od_near}</td>
                          </tr>
                          <tr>
                            <td>OS: {pprops.exam.pupillary_distance.os_distance}</td>
                            <td>OS: {pprops.exam.pupillary_distance.os_intermediate}</td>
                            <td>OS: {pprops.exam.pupillary_distance.os_near}</td>
                          </tr>
                          <tr>
                            <td>OU: {pprops.exam.pupillary_distance.ou_distance}</td>
                            <td>OU: {pprops.exam.pupillary_distance.ou_intermediate}</td>
                            <td>OU: {pprops.exam.pupillary_distance.ou_near}</td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  }
                </div>
                <div className='col-8 mt-3'>
                  {!isTemplate && (fields.length === index + 1) &&
                    <button type="button" className="btn btn-primary float-right" onClick={() => this.handleAddNew()}>
                      <i className='la la-plus mr-2 font-size-16'></i>
                      Add New
                    </button>
                  }
                  {!isTemplate &&
                    <button type="button" className="btn btn-outline-danger mr-7 float-right" aria-label="Close" onClick={() => { pprops.dispatch(change(formName, `${member}[_destroy]`, true)); setTimeout(() => pprops.submit(), 500) }}>
                      Remove Prescription
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        )
        )}
      </span>
    );
  }
}

const EyeGlassPrescription = props => {
  const { template, isTemplate, pprops, showPrescriptionModal, prescriptionData, examFinalizePrescriptionData, prescription, prescriptionModule, } = props
  const name = isTemplate ? "finalize_prescription[eye_glass][eye_glasses]" : "finalized_glasses_attributes"
  return (
    <FieldArray name={name}
      props={{
        template: template,
        isTemplate: isTemplate,
        pprops: pprops,
        prescription,
        prescriptionModule,
        formValues: (showPrescriptionModal || prescription?.id) ? prescriptionData : examFinalizePrescriptionData,
        formName: (showPrescriptionModal || prescription?.id) ? 'PrescriptionForm' : 'examFinalizePrescriptionForm',
      }}
      component={RenderGlass} />
  );
}

const mapStateToProps = (state) => {
  const { reports: { editing }, form: { PrescriptionForm, examFinalizePrescriptionForm } } = state;

  return {
    showPrescriptionModal: editing?.showPrescriptionModal,
    prescriptionData: PrescriptionForm?.values || {},
    examFinalizePrescriptionData: examFinalizePrescriptionForm?.values || {},
  }
}

export default connect(mapStateToProps)(EyeGlassPrescription);





